import React, { useEffect, useState } from 'react'
import dayjs from 'dayjs'

import ListView from '_components/list-view'
import MediaMeasurementCampaignsStatusBadge from '_components/media-measurement-campaign-status-badge'

const UrlSimilaritySeedsListView = ({
  className,
  hideControls,
  hideStatusFilter,
  statusFilterOptions = ['draft', 'submitted', 'processed', 'invalid'],
  renderItemActions,
  ...props
}) => {
  const [createdByOptions, setCreatedByOptions] = useState([])

  useEffect(() => {
    function load() {
      window._api.get('/custom-audiences/enum/created_by.email', (error, items) => {
        setCreatedByOptions(items)
      })
    }
    load()
  }, [])

  return (
    <ListView
      className={className}
      columns={[
        {
          name: 'Name',
          key: 'name',
          styles: {
            textAlign: 'left',
          },
          sortable: !hideControls,
        },
        {
          name: 'Status',
          key: 'status',
          styles: {
            textAlign: 'left',
          },
          // eslint-disable-next-line react/display-name
          render: (item) => <MediaMeasurementCampaignsStatusBadge status={item.status} />,
          sortable: !hideControls,
        },
        {
          name: 'Created At',
          key: 'created_at',
          styles: {
            maxWidth: '130px',
            textAlign: 'left',
          },
          // eslint-disable-next-line react/display-name
          render: (item) => <span>{dayjs(item.created_at).format('MM/DD/YYYY HH:mm')}</span>,
          sortable: !hideControls,
        },
        {
          name: 'Created By',
          key: 'created_by.email',
          styles: {
            maxWidth: '200px',
            textAlign: 'left',
          },
          sortable: !hideControls,
        },
        {
          name: 'Updated At',
          key: 'updated_at',
          styles: {
            maxWidth: '130px',
            textAlign: 'left',
          },
          // eslint-disable-next-line react/display-name
          render: (item) => <span>{dayjs(item.updated_at).format('MM/DD/YYYY HH:mm')}</span>,
          sortable: !hideControls,
        },
        {
          name: 'Updated By',
          key: 'updated_by.email',
          styles: {
            maxWidth: '200px',
            textAlign: 'left',
          },
          sortable: !hideControls,
        },
        ...(renderItemActions
          ? [
              {
                name: 'Actions',
                styles: {
                  maxWidth: '200px',
                  textAlign: 'left',
                },
                // eslint-disable-next-line react/display-name
                render: renderItemActions,
              },
            ]
          : []),
      ]}
      entities="url-similarity-seeds"
      searchable={!hideControls}
      extractItems={(resp) => resp.items}
      extractCount={(resp) => resp.items.length}
      filters={
        !hideControls && [
          ...(!hideStatusFilter
            ? [
                {
                  name: 'status',
                  label: 'Status',
                  options: statusFilterOptions,
                  all: true,
                },
              ]
            : []),
          {
            name: 'created_by.email',
            label: 'Created by',
            options: createdByOptions,
            all: true,
            className: 'audiences__filters',
          },
        ]
      }
      sort_key={'updated_at'}
      sort_dir={-1}
      {...props}
    />
  )
}

export default UrlSimilaritySeedsListView
